import React from 'react';
import Toggle from '../SideDrawer/Toggle';
import {NavLink} from 'react-router-dom'
import { useLocale } from '../../localization/LocaleContext';
import './toolbar.css';

const Toolbar = props => {
    const { t, toLocalizedPath } = useLocale();

    return (
        <header className="toolbar">
            <nav className="toolbar-navigation">
                <NavLink exact={true} to={toLocalizedPath('home')}>
                    <div className="toolbar-logo">
                        <img src={`${process.env.PUBLIC_URL}/images/main-logo.svg`} alt="Invoice Point logo" />
                    </div>
                </NavLink>
                <div className="spacer"></div>
                <Toggle click={props.drawerClickHandler} />
                <div className="toolbar-navigation-items">
                    <ul>
                        <li>
                            <NavLink exact={true} activeStyle={{borderBottom:"2px solid #fff"}} to={toLocalizedPath('home')}>
                                {t('nav.home')}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink activeStyle={{borderBottom:"2px solid #fff"}} to={toLocalizedPath('freelancers')}>
                                {t('nav.freelancers')}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink activeStyle={{borderBottom:"2px solid #fff"}} to={toLocalizedPath('smallBusiness')}>
                                {t('nav.smallBusiness')}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink activeStyle={{borderBottom:"2px solid #fff"}} to={toLocalizedPath('organization')}>
                                {t('nav.organization')}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink activeStyle={{borderBottom:"2px solid #fff"}} to={toLocalizedPath('faqs')}>
                                {t('nav.faqs')}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink activeStyle={{borderBottom:"2px solid #fff"}} to={toLocalizedPath('pricing')}>
                                {t('nav.pricing')}
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    )
}

export default Toolbar;